'use client';
import { createContext, useContext, useEffect, useState } from 'react';
import {
  THEMES,
  defaultTheme,
  normalizeTheme,
  isDarkTheme,
} from '@/constants/themes';

const ThemeContext = createContext();

const clearHtmlThemeLeak = () => {
  const html = document.documentElement;
  THEMES.forEach((t) => html.classList.remove(t.id));
  html.classList.remove('dark');
  const htmlTheme = html.getAttribute('data-theme');
  if (htmlTheme && THEMES.some((t) => t.id === htmlTheme)) {
    html.removeAttribute('data-theme');
  }
};

export const applyTheme = (themeId, themeRoot) => {
  clearHtmlThemeLeak();
  if (!themeRoot || !themeId) return;

  THEMES.forEach((t) => themeRoot.classList.remove(t.id));
  themeRoot.classList.add(themeId);
  themeRoot.setAttribute('data-theme', themeId);
  if (isDarkTheme(themeId)) {
    themeRoot.classList.add('dark');
  } else {
    themeRoot.classList.remove('dark');
  }
};

export const ThemeProvider = ({ children, initialTheme, themeRoot }) => {
  const normalized = normalizeTheme(initialTheme || localStorage.getItem('theme'));
  const [theme, setThemeState] = useState(normalized);

  useEffect(() => {
    const saved = normalizeTheme(initialTheme || localStorage.getItem('theme') || defaultTheme);
    setThemeState(saved);
    applyTheme(saved, themeRoot);
  }, [initialTheme, themeRoot]);

  return (
    <ThemeContext.Provider value={{ theme , isDark: isDarkTheme(theme) }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
